import { PrintMap } from "@esdm/map/dist/map/tools/PrintMap";
import { IPrintOptions } from "@esdm/map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "@esdm/map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "@esdm/map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "@esdm/map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "@esdm/map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "@esdm/map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "@esdm/map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "@esdm/map/dist/map/store/MapViewStore";
import { MapContextMenu } from "@esdm/map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "@esdm/map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "@esdm/map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "@esdm/map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "@esdm/map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "@esdm/map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { LayerGroupFactory } from "@esdm/map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "@esdm/map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "@esdm/map/dist/map/filters/MapFilters";

import { IMappingTextPack } from "@esdm/map/dist/resources/MappingTextPack";
import { FeatureAdd, FeatureAddSmallGeomsAsPoint } from "@esdm/map/dist/layers/vector/sources/loaders";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "@esdm/map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "@esdm/map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "@esdm/map/dist/baselayers/interfaces/IBaseLayerFactory";
import { FilterType } from "@esdm/map/dist/map/filters/FilterType";
import { VectorLayerStrategy } from "@esdm/map/dist/layers/vector/VectorLayerStrategy";
import { ZoomToDataBounds } from "@esdm/map/dist/layers/vector/ZoomToDataBounds";
import { MousePosition } from "@esdm/map/dist/map/controls/MousePosition";
import { MouseWheelZoom } from "@esdm/map/dist/map/controls/MouseWheelZoom";

import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapListRecordItem,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    MapFeatureInfo
} from "@esdm/map";
import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { PortsmouthRecordType, PortsmouthRecordSubType } from "./PortsmouthRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { PortsmouthHerBoundary } from "./PortsmouthHerBoundary";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { TextPacks, TextPackLoader } from "./TextPackLoader";
import { HbsmrIdentity, HbsmrUser } from "./HbsmrUser";
import { MapBase } from "./MapBase";
import { IDragPanControl } from "@esdm/map/dist/map/controls/interfaces/IDragPanControl";
import { DragPanControl } from "@esdm/map/dist/map/controls/DragPanControl";
import { LayerGroupCollections } from "@esdm/map/dist/layers/groups/LayerGroupCollections";
import { IlayerGroupCollectionConfig } from "@esdm/map/dist/layers/groups/IlayerGroupCollectionConfig";
import { PortsmouthBaseMapping_3857 } from "./PortsmouthBaseMapping_3857";
import { WfsBboxAsWktRequestParams, WfsParamSourceMapServer } from "@esdm/map/dist/layers/vector/sources/wfs";

$(document).ready(function () {
    let printOptions: PrintMap = new PrintMap();
    let ele = $("#theMap");
    if (ele.length === 1) {
        HbsmrIdentity.fetch().then(function (e) {
            let user = e;
            let maxFeatureCount: number = <number>ele.data("max-feature-count");
            let mapData = $("#SingleRecordMapData");
            let recordType: string = mapData.data("record-type");

            let init = function (textpacks: TextPacks) {                
                let map: MapSingleRecord = new MapSingleRecord("theMap", recordType, null, maxFeatureCount, printOptions, textpacks.mapping, user);
            }
            TextPackLoader.load().then(init);
        });
    }
});


export class MapSingleRecord extends MapBase{

    private map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private initialised: boolean = false;
    private loadingCount = 0;
    private mfOptions: MapOptions;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;
    private infoPopup: MapFeatureInfo;
    private logger: ILogger;
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mousePosition: MousePosition;
    private dragPan: IDragPanControl; 

    constructor(
        private _mapElementId: string,
        private _recordType: string,
        private _recordSubType: string,
        private _maxRecordCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: HbsmrUser)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }

        $("#slide-panel-btn-tools").hide();

        this.layerConfigFactory = new DefaultLayerConfigurationFactory();
        this.vectorLayerGroupFactory = new VectorLayerGroupFactory();
        this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, null);
        this.baseLayerFactory = new PortsmouthBaseMapping_3857();
        this.featureLoader = new GeoJsonFeatureLoader();

        this.featureAdd = new FeatureAddSmallGeomsAsPoint(4.5);
        //this.featureAdd = new FeatureAdd();

        this.mapFactory = new MapFactory();
        this.logger = new Logger();
        this.styleFactory = new HbsmrStyleFactory();
        this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

        this.mapFilter = new MapFilters();
        this.mapFilter.OgcFilter = new OgcMapFilter();

        this.mfOptions = DefaultMapOptions.GetDefaultOptions(this._mapElementId, "SingleRecordMap27700");
        this.mfOptions.mapZoom = 16;

        this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
        this.mfOptions.layerGroupCollection = this.layerGroups;

        this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey);
        //clear the store so we don't remember the layers etc?
        this.mapStore.clear();

        this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
        this.herMask = new PortsmouthHerBoundary();
        this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
        this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
        this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);

        //this.map.olMap.addLayer(this.herMask.getMask());

        this.dragPan = new DragPanControl(this.map, this.mappingTextPack);
        this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);
        this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, null, {
            showList: false,
            showOpenPanelByDefault: false,
            rememberActivePanel: true
        });

        if (this.printOptions.isPrintMap) {
            this.printOptions.setMap(this.map);
            this.map.olMap.on('postrender', () => {
                var osFound = false;
                var blueskyFound = false;

                if ($("#printMapAttributions > div").length > 0) {
                    $("#printMapAttributions > div > ul > li").each(function () {
                        if ($(this).text().includes(" OS ")) {
                            osFound = true;
                        }

                        if ($(this).text().includes(" Bluesky ")) {
                            blueskyFound = true;
                        }

                        if (!osFound) {
                            $("#osTerms").hide();
                        } else {
                            $("#osTerms").show();
                        }

                        if (!blueskyFound) {
                            $("#blueskyTerms").hide();
                        } else {
                            $("#blueskyTerms").show();
                        }
                    });
                }
            });
        }
        //this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);        
        this.mousePosition = new MousePosition(this.map, this.mappingTextPack);

        //hide the gazetteer, temp fix possibly pending redoing of the html
        $("#slide-panel-btn-search").hide();

        this.ctrlZoomHandler();

        this.initialised = true;
    }

    private ctrlZoomHandler = (): void => {
        let z = new MouseWheelZoom(this.map, this.mappingTextPack);
        $("#slide-panel,#slide-headers,.ol-control,#mouse-position,.ol-scale-line").on('wheel', function (e) {
            e.preventDefault();
        });
    }

    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {
        let url: string = "/api/OgcService/hbsmr";

        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            //THE SELECTED RECORD           
            {
                ref: "SelectedRecord",
                displayName: "Selected record",
                type: this._recordType,
                subType: this._recordSubType,
                strategy: VectorLayerStrategy.OgcFilterAll,
                zoomToDataBounds: ZoomToDataBounds.Always,
                useSelectedStyle: true,
                visibleOnLoad: true,
                displayInLayerSwitcher: true,
                wfsParams: new WfsParamSourceMapServer(new WfsBboxAsWktRequestParams(), { srsName: "EPSG:27700" }),
                url: url,
                queryable:false,
                legend: { polygon: false, line: false },
                restrictMapExtentToDataBounds: true,
                filterOptions: {
                    filterType: FilterType.Ogc,
                    filters: ["Uid"],
                },
                layers: [
                    {
                        layerName: `${this.getLayerNameFromType()}PolygonsWFS`,
                        minZoom: 1,
                        maxZoom: 19
                    }
                    ,
                    {
                        layerName: `${this.getLayerNameFromType()}LinesWFS`,
                        minZoom: 1,
                        maxZoom: 19
                    },
                    {
                        layerName: `${this.getLayerNameFromType()}PointsWFS`,
                        minZoom: 1,
                        maxZoom: 19
                    },
                ]
            },
            this.layerConfigFactory.layerConfig(PortsmouthRecordType.Monument, null, { visibleOnLoad: true }),
            this.layerConfigFactory.layerConfig(PortsmouthRecordType.Event, null),
            this.layerConfigFactory.layerConfig(PortsmouthRecordType.Designation, PortsmouthRecordSubType.ListedBuilding),
            this.layerConfigFactory.layerConfig(PortsmouthRecordType.Designation, PortsmouthRecordSubType.ScheduledMonument),
            this.layerConfigFactory.layerConfig(PortsmouthRecordType.Designation, PortsmouthRecordSubType.RegisteredParksAndGardens)

        ];
        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];
    }

    public getLayerNameFromType = (): string => {
        let name: string = null;
        let recordType = this._recordType;
        let recordSubType = this._recordSubType;

        switch (recordType) {
            case PortsmouthRecordType.Monument:
                name = "Monument"
                break;

            case PortsmouthRecordType.Event:
                name = "Event"
                break;

            case PortsmouthRecordType.Designation:
                name = "Designation"
                break;
        }


        if (name === null && recordSubType !== null) {
            switch (recordSubType) {

                case PortsmouthRecordSubType.ScheduledMonument:
                    name = "ScheduledMonument";
                    break;

                case PortsmouthRecordSubType.RegisteredParksAndGardens:
                    name = "RegisteredParksGardens";
                    break;

                case PortsmouthRecordSubType.ListedBuilding:
                    name = "ListedBuildings";
                    break;             
            }
        }
        return name;
    }
}

